
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/view/cookies_policy",
      function () {
        return require("private-next-pages/view/cookies_policy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/view/cookies_policy"])
      });
    }
  